<template>
  <header class="header">
    <div class="wrapper">
      <!-- Logo Section -->
      <div class="left">
        <router-link to="/home" class="logo">
          <div class="title">island<span>nook</span></div>
        </router-link>
      </div>

      <!-- Navigation Section -->
      <ul class="nav">
        <li v-for="item in $parent.nav" :key="item.title" class="nav-item">
          <router-link class="nav-link" :to="item.path">
            {{ $t(item.title) }}
          </router-link>
        </li>
      </ul>

      <!-- Right Section -->
      <div class="right">
        <!-- Currency Selector -->
        <div class="language-switch">
          <v-select
            :options="currencyOptions"
            :reduce="opt => opt.value"
            label="label"
            v-model="currentCurrency"
            :clearable="false"
            :searchable="false"
          />
        </div>

        <!-- If Authenticated -->
        <router-link
          v-if="$parent.isAuth"
          to="/profile/personal-information"
          class="user-card"
        >
          <div class="user-nickname">{{ $parent.name }}</div>
          <div class="user-icon">
            <img src="./../assets/user.svg" alt="User Icon" />
          </div>
        </router-link>

        <!-- If Not Authenticated -->
        <div v-else class="auth-actions">
          <button class="nav-link" @click="openSignIn">
            {{ $t("Login") }}
          </button>
          <button class="button" @click="openSignUp">
            {{ $t("Sign Up") }}
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { MODALS } from "../store/modules/modals";
import vSelect from "vue-select";

export default {
  name: "Header",
  components: {
    "v-select": vSelect,
  },
  props: [],
  data() {
    return {};
  },
  computed: {
    // Use getters from the currency store
    ...mapGetters("currency", {
      currencyOptions: "currencyOptions",
      currentCurrencyValue: "currentCurrency",
    }),
    // v-model proxy to allow setting through action
    currentCurrency: {
      get() {
        return this.currentCurrencyValue;
      },
      set(val) {
        this.$store.dispatch("currency/setCurrency", val);
      },
    },
  },
  created() {
    this.$store.dispatch("currency/initCurrency");
  },
  methods: {
    ...mapActions("modals", ["openLoginModal", "openSignupModal"]),

    openSignIn() {
      this.$store.dispatch("modals/openModal", {
        modalName: MODALS.LOGIN,
      });
    },
    openSignUp() {
      this.$store.dispatch("modals/openModal", {
        modalName: MODALS.SIGNUP,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* General Header Styles */
.header {
  padding: 40px 16px 0;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  background: transparent;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* Logo Section */
.left {
  display: flex;
  flex: 1;
  align-items: center;
}

.logo .title {
  color: #fff;
  font-size: 28px;
  line-height: 32px;
  font-weight: 700;
}

.logo .title span {
  color: #a1d6f4;
}

/* Navigation Styles */
.nav {
  display: flex;
  gap: 45px;
  align-items: center;
  justify-content: center;
}

.nav-item {
  text-align: center;
  text-transform: uppercase;
}

.nav-link {
  display: block;
  color: #fff;
  line-height: 32px;
  text-transform: uppercase;
  font-weight: 500;

  text-decoration: none;
  transition: color 0.3s ease;
}

/* Right Section */
.right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  gap: 16px;
}

.language-switch {
  min-width: 140px;
}

/* vue-select overrides to match theme */
::v-deep .v-select {
  width: 160px;
}
::v-deep .vs__dropdown-toggle {
  background: #112a3a;
  border: 1px solid #ffffff;
  border-radius: 20px;
  min-height: 39px;
  max-height: 37px;
  padding: 2px 36px 2px 12px;
}
::v-deep .vs__selected,
::v-deep .vs__selected-options,
::v-deep .vs__search {
  color: #fff;
}
::v-deep .vs__search::placeholder {
  color: #fff;
  opacity: 0.8;
}
::v-deep .vs__actions {
  align-items: center;
}
::v-deep .vs__open-indicator {
  fill: #fff;
}
::v-deep .vs__clear {
  display: none;
}
::v-deep .vs__dropdown-menu {
  background: #f0f2f3;
  border: 1px solid #aaabb6;
  border-radius: 6px;
  color: #1c1c2e;
}

/* User/Auth */
.auth-actions {
  display: flex;
  gap: 30px;
}
.auth-actions .nav-link {
  font-size: 16px;
}

.button {
}

.button:hover {
}

/* User Card */
.user-card {
  display: flex;
  align-items: center;
  gap: 13px;
  background: transparent;
  text-decoration: none;
  transition: all 0.3s ease-in-out;
  height: 46px;
}

.user-nickname {
  font-size: 18px;
  line-height: 32px;
  color: #fff;
  white-space: nowrap;
  transition: color 0.3s ease;
}

.user-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #112a3a;
  border-radius: 50%;
  transition: background 0.3s ease-in-out, border 0.3s ease-in-out;
}

.user-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* Responsive Styles */
@media screen and (max-width: 768px) {
  .wrapper {
    gap: 16px;
    flex-direction: column;
  }

  .nav {
  }

  .right {
    justify-content: center;
  }
}
</style>
